<template>
  <div class="number-range flex-container">
    <!--numberType int Double isValid-->
    <el-input
      ref="rangeFrom"
      class="number-input"
      :class="{'range-input-error':!isValid}"
      v-model="value.from"
      placeholder="最小值"
      @input.native="(e)=>{e.target.value=handleNumber(e.target.value,value.numberType,'from')}"
      @change="val=>validate(val,'from')"
    />
    <span class="seperator">-</span>
    <el-input
      ref="rangeTo"
      class="number-input"
      :class="{'range-input-error':!isValid}"
      v-model="value.to"
      placeholder="最大值"
      @input.native="(e)=>{e.target.value=handleNumber(e.target.value,value.numberType,'to')}"
      @change="val=>validate(val,'to')"
    />
  </div>
</template>
<script>
export default {
  name: 'NumberRange',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      value: {},
      isValid: true
    }
  },
  computed: {},
  watch: {
    item: {
      handler(newVal) {
        this.value = { ...newVal }
      },
      immediate: true
    }
  },
  methods: {
    handleNumber(value, numberType, key) {
      const handledValue = numberType === 'Int' ? value.replace(/[^\d]/g, '') : value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{2}).*$/g, '$1')
      this.value[key] = handledValue
      return handledValue
    },
    validate(val, key) {
      this.value[key] = val
      const { from, to } = this.value
      if (!from || !to || Number(from) <= Number(to)) {
        this.isValid = true
      } else {
        this.isValid = false // 输入框变色
      }
      this.$emit('range-changed', { isValid: this.isValid, value: this.value })
    }
  }
}
</script>
<style lang='less' scoped>
.number-input{
  width: 70px;
  &.range-input-error{
    /deep/ .el-input__inner{
      border: 1px solid red;
    }
  }
}
.seperator{
    display: inline-block;
    line-height: 24px;
    margin: 0 4px;
  }
</style>
